export const defaultFaviconLink =
  'https://firebasestorage.googleapis.com/v0/b/droov-group-1.appspot.com/o/Defaults%2FfaviconDefaults.png?alt=media&token=924d1962-269c-4b91-bb17-1de18e622f79';
export const defaultLogoLink =
  'https://firebasestorage.googleapis.com/v0/b/droov-group-1.appspot.com/o/Defaults%2FlogoDefaults.png?alt=media&token=cf148358-8ace-413a-9e3c-6fe1b55ae37b';
export const defaultCoverLink =
  'https://firebasestorage.googleapis.com/v0/b/droov-group-1.appspot.com/o/Defaults%2FcoverDefaults.png?alt=media&token=9aaa057e-4370-4187-82ed-b7c224ebc959';
export const defaultColor = 'Lime';
